import React from 'react';
import { DataTable, EmptyState, TableSkeleton } from '../../../components/ui';
import useProfileSx from '../hooks/useProfileSx';
import { useProfileTableColumns } from '../config/profileTableConfig';

export default function ProfileListTable({
  profiles,
  loading,
  page,
  pageSize,
  onEdit,
  onPermissions,
  onClone,
  onDelete,
  canEdit = false,
  canManagePermissions = false,
  canClone = false,
  canDelete = false,
  showOrganisationColumn = false,
}) {
  const { tableOverrides } = useProfileSx();
  const columns = useProfileTableColumns({
    page,
    pageSize,
    onEdit,
    onPermissions,
    onClone,
    onDelete,
    accentColor: tableOverrides.accentPrimary,
    canEdit,
    canManagePermissions,
    canClone,
    canDelete,
    showOrganisationColumn,
  });

  return (
    <DataTable
      columns={columns}
      data={profiles}
      loading={loading}
      getRowId={(row) => String(row.id)}
      aria-label="Profile list"
      emptyState={
        <EmptyState
          title="No profiles found"
          description="Create a profile or adjust your search and filters."
        />
      }
      skeleton={<TableSkeleton rowCount={pageSize} columnCount={showOrganisationColumn ? 5 : 4} />}
      muiTableHeadCellProps={tableOverrides.muiTableHeadCellProps}
      muiTableBodyCellProps={tableOverrides.muiTableBodyCellProps}
      muiTableBodyRowProps={tableOverrides.muiTableBodyRowProps}
      muiTableContainerProps={tableOverrides.muiTableContainerProps}
    />
  );
}
